module.exports = __webpack_public_path__ + "static/media/thumbnail_sharona.888a0850.jpg";